import { fetchVouchers } from "../../../app/api/manageVoucher";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IFetchVouchersActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/VoucherActionParams";
import { IVoucherData } from "../../../Orchestrator/Types/Interface/IVoucher";

export class FetchVouchersAction extends BaseAction<IVoucherData[], IFetchVouchersActionParams> {
    override async run(): Promise<IVoucherData[]> {
        const { userId } = this.params!
        let voucherData: IVoucherData[] = [];
        try {

            const response: any = await fetchVouchers(userId);
            if (response.status === "ok" && response.answer) {
                voucherData = response.answer;
                updateRecoilState("voucherDataAtom", voucherData)
            }
        }
        catch (error) {
            console.error("Error during fetching vouchers:", error);
        }
        finally {
            return voucherData;
        }
    }
}
export const fetchVouchersAction = new FetchVouchersAction();
